import React from "react";
import {
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Typography,
  makeStyles,
} from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  primary: { whiteSpace: "pre-line" },
}));
const CommentItem = ({ comment, author }) => {
  const classes = useStyles();
  let dateString = new Date(comment.erstellt.seconds * 1000).toLocaleString(
    "de-DE"
  );
  dateString = dateString.substring(0, dateString.length - 3);
  return (
    <ListItem key={comment.id}>
      <ListItemAvatar>
        <Avatar />
      </ListItemAvatar>
      <ListItemText
        primary={
          <Typography type="body2" className={classes.primary}>
            {comment.kommentar}
          </Typography>
        }
        secondary={(author ? author.displayName + " - " : "") + dateString}
      />
    </ListItem>
  );
};
export default CommentItem;
